module.exports = __webpack_public_path__ + "img/img-trading-04.784db67b.png";